import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';

@Component({
  selector: 'app-image-classifier',
  templateUrl: './image-classifier.component.html',
  styleUrls: ['./image-classifier.component.css']
})
export class ImageClassifierComponent implements OnInit, OnChanges, AfterViewInit {
  
  ngOnInit(): void {
    //this.imageSrc = "https://tasfirecameras.blob.core.windows.net/videos/Video/in-restapi-restapi-southsistersmanual/2024/03/26/084727.jpeg";
  }

  ngAfterViewInit() {
    this.loadImage();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.loadImage();
  }

  public image: any;
  public boundingBoxes: { x: number; y: number; width: number; height: number }[] = [];
  public classification: { x: number; y: number; width: number; height: number, imageWidth: number, imageHeight: number };


  public imgWidth: number;
  public imgNaturalWidth: number;
  public imgHeight: number;
  public imgNaturalHeight: number;
  public confidencePercentage: number = 0; // Default slider value (0-100)

  @Input() public imageSrc: string; // New property to store the image source
  @Input() public shown: boolean = true; // New property to store the image source
  @Output() onSelectionComplete = new EventEmitter<any>();

  //@ViewChild('image', { static: false }) imageSource: ElementRef;
  //@ViewChild('imageSource') imageSource: ElementRef;
  @ViewChild('imageSource', {read: ElementRef}) imageSource: ElementRef;
  @ViewChild('layer1', {read: ElementRef}) layer1Canvas: ElementRef;
  //@ViewChild('layer1', { static: false }) layer1Canvas: ElementRef;
  private context: CanvasRenderingContext2D;
  private layer1CanvasElement: any;

  loadImage(){
    if (this.layer1Canvas) {
      this.layer1CanvasElement = this.layer1Canvas.nativeElement;
      this.context = this.layer1CanvasElement.getContext('2d');
      const img = this.imageSource.nativeElement;
        img.onload = (i: any) => {
          this.image = new Image();
          this.image.src = i.target.result;
          this.imgWidth = img.width;
          this.imgHeight = img.height;
          this.imgNaturalWidth = img.naturalWidth;
          this.imgNaturalHeight = img.naturalHeight;
        };
    }
  }

  showImage() {   
    const img = new Image();
    img.src = this.imageSrc;
    img.onload = () => {
      this.context.drawImage(img, 0, 0, this.imgWidth, this.imgHeight);
      this.drawBoundingBoxes();
    };
  }

  drawBoundingBoxes() {
    this.context.clearRect(0, 0, this.imgWidth, this.imgHeight); // Clear canvas
    this.boundingBoxes.forEach(box => {
      this.context.beginPath();
      this.context.rect(box.x, box.y, box.width, box.height);
      this.context.lineWidth = 2;
      this.context.strokeStyle = 'red';
      this.context.stroke();
    });
  }

  drawing: boolean;
  onMouseDown(event: MouseEvent) {
    console.log("onMouseDown")
    const rect = this.layer1CanvasElement.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    if (!this.drawing){
      if (this.boundingBoxes.length == 0){
        this.boundingBoxes.push({ x, y, width: 0, height: 0 });
      }else{
        this.boundingBoxes[0] = { x, y, width: 0, height: 0 };
      }      
      this.drawBoundingBoxes();
      this.drawing = true;
    } else {
      const rect = this.layer1CanvasElement.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;
      const currentBox = this.boundingBoxes[0];
      currentBox.width = x - currentBox.x;
      currentBox.height = y - currentBox.y;
      this.drawBoundingBoxes();
      this.drawing = false;
      // convert x/y etc into coordinates on the image
      const xfactor = this.imgNaturalWidth/this.imgWidth;
      const yfactor = this.imgNaturalHeight/this.imgHeight;
      this.classification = {
        x:Math.round(currentBox.x*xfactor),
        y:Math.round(currentBox.y*yfactor),
        width:Math.round(currentBox.width*xfactor),
        height:Math.round(currentBox.height*yfactor),
        imageWidth: this.imgNaturalWidth,
        imageHeight: this.imgNaturalHeight
      };
      this.emitSelection();
    }
  }

  x:number;
  y:number;

  onMouseMove(event: MouseEvent) {
    const rect = this.layer1CanvasElement.getBoundingClientRect();
    this.x = event.clientX - rect.left;
    this.y = event.clientY - rect.top;
    if (this.drawing && this.boundingBoxes.length > 0) {      
      const currentBox = this.boundingBoxes[this.boundingBoxes.length - 1];
      currentBox.width = this.x - currentBox.x;
      currentBox.height = this.y - currentBox.y;
      this.drawBoundingBoxes();
    }
  }

  onMouseUp() {
    // Save or process the bounding boxes as needed
  }

  onConfidenceChange() {
    if (this.classification) {
      this.emitSelection();
    }
  }

  private emitSelection() {
    const confidence = this.confidencePercentage; // Convert 0-100 to 0-1
    this.onSelectionComplete.emit({
      ...this.classification,
      confidence: confidence
    });
  }
}
